module.exports = __webpack_public_path__ + "img/tap_store.42852ca.png";